// extracted by mini-css-extract-plugin
module.exports = {"inclusive":"Price_inclusive__2Ewb8"};